import { ErrorHandler, Injectable } from '@angular/core';
import { ClientStorage } from '../std/client-storage';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  handleError(error: any): void {
    const fetchModuleFailed = /Failed to fetch dynamically imported module/;

    if (fetchModuleFailed.test(error.message)) {
      console.log("Retry after 'Failed to fetch dynamically imported module...'");
      window.location.reload();
    }
  }
}